import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { LicenseActivationPage } from '@app/pages/license/license-activation-page';
import { licenseActivationService } from '@common/licensing/license-activation-service';
import auth from '@common/auth/auth';
import { ForbiddenPage } from './forbidden-page';
export function RestrictedPage(props) {
    const { roles, children, insufficientRolesComponent, unauthorizedComponent, noLicenseAvailability } = props;
    if (!auth.isAuthenticated()) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return _jsx(_Fragment, { children: unauthorizedComponent !== null && unauthorizedComponent !== void 0 ? unauthorizedComponent : _jsx(ForbiddenPage, {}) });
    }
    if (!licenseActivationService.hasLicense() && !noLicenseAvailability) {
        return _jsx(LicenseActivationPage, {});
    }
    if ((roles === null || roles === void 0 ? void 0 : roles.length) && !auth.hasRoles(roles)) {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return _jsx(_Fragment, { children: insufficientRolesComponent !== null && insufficientRolesComponent !== void 0 ? insufficientRolesComponent : _jsx(ForbiddenPage, {}) });
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return _jsx(_Fragment, { children: children });
}
